import { AgxBadge, type BadgeColor } from '@urbanx/agx.ui-components2';
import { MarketingPackageProjectionDisplayStatus } from '@urbanx/agx.marketing.client';

const getBadgeSize = (small: boolean) => (small ? 'sm' : 'md');

const paymentStatusBadge = (
  text: string,
  colour: BadgeColor,
  small: boolean
) => (
  <AgxBadge
    size={getBadgeSize(small)}
    text={text}
    type="colourfill"
    colour={colour}
  />
);

export const mapPaymentStatus = (
  status?: MarketingPackageProjectionDisplayStatus,
  small: boolean = false
) => {
  if (status === undefined || status === null) return <></>;

  switch (status) {
    case MarketingPackageProjectionDisplayStatus.Draft:
    case MarketingPackageProjectionDisplayStatus.AwaitingFunds:
      return paymentStatusBadge('Awaiting Funds', 'purple', small);
    case MarketingPackageProjectionDisplayStatus.PayLaterApplicationSigned:
      return paymentStatusBadge('Pay Later Application Signed', 'blue', small);
    case MarketingPackageProjectionDisplayStatus.Paid:
      return paymentStatusBadge('Paid', 'green', small);
    case MarketingPackageProjectionDisplayStatus.Cancelled:
      return paymentStatusBadge('Cancelled', 'lightgrey', small);
    case MarketingPackageProjectionDisplayStatus.PendingSettlement:
      return paymentStatusBadge('Pending Settlement', 'blue', small);
    case MarketingPackageProjectionDisplayStatus.Complete:
      return paymentStatusBadge('Complete', 'blue', small);
    case MarketingPackageProjectionDisplayStatus.Withdrawn:
      return paymentStatusBadge('Withdrawn', 'red', small);
    case MarketingPackageProjectionDisplayStatus.PayLaterDeclined:
      return paymentStatusBadge('Pay Later Declined', 'red', small);
    default:
      return <></>;
  }
};
